import { Link } from "react-router-dom";
import { ArrowRight, Users, Sparkle } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function CHero() {
  return (
    <section
      data-testid="c-hero"
      className="relative pt-36 pb-24 md:pt-44 md:pb-32 overflow-hidden bg-[#FAF7F8]"
    >
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div className="absolute top-10 -left-32 w-[44rem] h-[44rem] rounded-full bg-[#3A2E6E]/10 blur-[140px]" />
        <div className="absolute -bottom-24 right-0 w-[34rem] h-[34rem] rounded-full bg-[#C98FA3]/25 blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/70 backdrop-blur border border-[#DDD7E2] text-xs uppercase tracking-[0.22em] text-[#3A2E6E]">
              <Sparkle className="w-3.5 h-3.5 text-[#C98FA3]" />
              Travail en groupe · Pratique centrale
            </span>
          </Reveal>

          <Reveal delay={0.1}>
            <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-[5.5rem] font-light leading-[1.02] tracking-tight mt-8 text-[#1E1E2A]">
              Constellations familiales
              <br />
              <span className="italic text-[#3A2E6E]">en groupe</span>
            </h1>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="mt-7 text-xl md:text-2xl font-serif-display text-[#3A2E6E] leading-snug max-w-2xl">
              Mettre en lumière les dynamiques invisibles.
            </p>
          </Reveal>

          <Reveal delay={0.28}>
            <p className="mt-6 text-base md:text-lg text-[#5F6170] leading-relaxed max-w-xl">
              Le travail en groupe permet de révéler des schémas familiaux ou
              relationnels qui restent souvent difficiles à percevoir seul.
            </p>
          </Reveal>

          <Reveal delay={0.36}>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Link
                to="/calendrier-ateliers"
                data-testid="c-hero-cta"
                className="group bg-[#2847B8] text-white hover:bg-[#3A2E6E] transition-all duration-300 rounded-full px-8 py-4 font-medium inline-flex items-center justify-center gap-2"
              >
                Voir les prochaines dates
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
              <a
                href="#how"
                data-testid="c-hero-cta-secondary"
                className="border-2 border-[#C98FA3] text-[#1E1E2A] hover:bg-[#C98FA3] hover:text-white transition-all duration-300 rounded-full px-8 py-4 font-medium text-center"
              >
                Comment ça se passe
              </a>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.3}>
            <div className="relative aspect-[4/5] rounded-[2.5rem] overflow-hidden bg-gradient-to-br from-[#3A2E6E] via-[#3A2E6E] to-[#2847B8] border border-[#DDD7E2] shadow-[0_30px_80px_-20px_rgba(58,46,110,0.35)]">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/6b768130-5bfa-4898-afec-a0670faefdd4/images/74e986d73216c2879f89e6db1c4875b207dc20b448d131e713a02fd2316e8f86.png"
                alt=""
                className="w-full h-full object-cover mix-blend-screen opacity-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#3A2E6E]/60 via-transparent to-transparent" />
              <div className="absolute bottom-8 left-8 right-8 text-white">
                <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#E6D6DF] font-medium">
                  <Users className="w-4 h-4" /> Groupe restreint
                </div>
                <p className="font-serif-display text-2xl mt-3 leading-tight">
                  Un cadre collectif, structuré et confidentiel.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
